module.exports = __webpack_public_path__ + "static/media/end-screen@2x.d99b3682.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/end-screen@2x.jpg
// module id = 529
// module chunks = 0